export enum ToastIds {
  JOIN_GAME_FAILED = "join-game-failed",
  CREATE_GAME_FAILED = "create-game-failed",
  LOBBY_IS_FULL = "lobby-is-full",
  USER_ALREADY_CONNECTED = "user-already-connected",
  RECONNECT_ERROR = "reconnect-error",
  CAST_VOTE_FAILED = "cast-vote-failed",
  REVEAL_VOTES_FAILED = "reveal-votes-failed",
  TASK_UPDATE_FAILED = "task-update-failed",
  TASK_REMOVE_FAILED = "task-remove-failed",
  TASK_CREATE_FAILED = "task-create-failed",
  NEW_VOTING_FAILED = "new-voting-failed",
  LINK_COPY_FAILED = "link-copy-failed",
  TASK_DESCRIPTION_TOO_LONG = "task-description-too-long",
  TASK_DESCRIPTION_TOO_SHORT = "task-description-too-short",
  ADD_TASK_FAILED = "task-addition-failed",
  DELETE_TASK_FAILED = "task-deletion-failed",
  UPDATE_TASK_FAILED = "task-update-failed",
  CONNECT_ERROR = "connect-error",
  RECONNECT_FAILED = "reconnect-failed",
  LINK_COPIED = "link-copied",
  USERNAME_TOO_LONG = "username-too-long",
  USERNAME_TOO_SHORT = "username-too-short",
  USER_UPDATE_FAILED = "user-update-failed",
  GAME_END_FAILED = "game-end-failed",
  TIMER_START_FAILED = "timer-start-failed",
  TIMER_STOP_FAILED = "timer-stop-failed",
  TIMER_ADD_TIME_FAILED = "timer-add-time-failed",
  TIMER_RESTRT_FAILED = "timer-restart-failed",
  TIMER_CANCEL_FAILED = "timer-cancel-failed",
}
